export const menuData_DBDesigner = [
    {
        name: "Home",
        level: "1",
        url: "/Designer",
        children: [
            {
                name: "Notō Designer",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Study Configurator",
                        level: "3",
                        url: "/Designer"
                    },
                    {
                        name: "Study Config - Zelta",
                        level: "3",
                        url: "/ZeltaStudyList"
                    },
                    {
                        name: "Paradigm Designer",
                        level: "3",
                        url: "/Paradigms"
                    },
                    {
                        name: "Custom Viewer",
                        level: "3",
                        url: "/CustomViewers"
                    },
                    {
                        name: "Dashboard Viewer",
                        level: "3",
                        url: "/DashboardViewer"
                    },
                    {
                        name: "Study Report",
                        level: "3",
                        url: "/StudyDesignerReport"
                    },
                    {
                        name: "Form Library Tag",
                        level: "3",
                        url: "/FormLibraryTagList"
                    }
                    
                    // Need to uncomment to integrate chart dashboard : Ashok P on 01 Aug 2025
                    //,{
                    //    name: "ChartJS Integration 01",
                    //    level: "3",
                    //    url: "ChartDashboard"
                    //}
                    //,{
                    //    name: "ChartJS Integration 02",
                    //    level: "3",
                    //    url: "/HomeDashboard"
                    //}
                ]
            },           
            {
                name: "Admin",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Global Settings",
                        level: "3",
                        url: "/GlobalSettings"
                    },
                    {
                        name: "Assign Role",
                        level: "3",
                        url: "/AssignUserRoleList"
                    },
                    {
                        name: "Assign User",
                        level: "3",
                        url: "/AssignUserByProject"
                    },
                    {
                        name: "Manage User",
                        level: "3",
                        url: "/ManageUserList"
                    },
                    {
                        name: "Email Designer",
                        level: "3",
                        url: "/EmailContentDesigner"
                    },
                    {
                        name: "Sponsors",
                        level: "3",
                        url: "/SponsorsList"
                    },
                    {
                        name: "Admin Toolkits",
                        level: "3",
                        url: "/AdminToolkits"
                    }
                ]
            },
            {
                name: "Image Services",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Dashboard",
                        level: "3",
                        url: "/Dashboard"
                    },
                    {
                        name: "Closed Tasks",
                        level: "3",
                        url: "/ClosedTaskDashboard"
                    },
                    {
                        name: "CR Current Tasks",
                        level: "3",
                        url: "/CRCurrentTask"
                    }
                ]
            },
            {
                name: "Report",
                level: "2",
                url: "",
                children: [
                    {
                        name: "Global Report Viewer",
                        level: "3",
                        url: "/GlobalReportViewer"
                    }
                ]
            }   
        ]
    },
    {
        name: "Help",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "Contact Support",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "About",
        level: "1",
        url: "/AboutUs",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    }
]